import { render } from "./MTextArea.vue?vue&type=template&id=751efb84&scoped=true"
import script from "./MTextArea.vue?vue&type=script&lang=js"
export * from "./MTextArea.vue?vue&type=script&lang=js"

import "./MTextArea.vue?vue&type=style&index=0&id=751efb84&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751efb84"]])

export default __exports__